import React, { useEffect } from "react";
import { Stack, Typography, Select, MenuItem } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { EnumCabinetMirrors, setBackPanel } from "../../../../store/cabinetMirror";
import { setBackPanelFiyatı } from "../../../../store/cabinetMirrorFee";
import RenderModal from "../../../OrtakComponents/Modal/RenderModal";

const ArkaPanel = () => {
  const dispatch = useDispatch();
  const { backPanel } = useSelector((state) => state.cabinetMirror);
  const { selectedMirror } = useSelector((state) => state.mirror);
  const handleChange = (e) => {
    dispatch(setBackPanel(e.target.value));
    dispatch(setBackPanelFiyatı(e.target.value === 0 ? 0 : e.target.value === 1 ? 169 : 99));
    isAluminium && dispatch(setBackPanelFiyatı(0));
  };
  const isAluminium = [
    EnumCabinetMirrors.HAVEL,
    EnumCabinetMirrors.LECH,
    EnumCabinetMirrors.WESER,
    EnumCabinetMirrors.ELBE_1,
    EnumCabinetMirrors.NECKAR,
    EnumCabinetMirrors.LIPPE,
    EnumCabinetMirrors.WERRA,
  ].includes(selectedMirror);
  useEffect(() => {
    if (isAluminium) {
      dispatch(setBackPanel(4));
      dispatch(setBackPanelFiyatı(0));
    } else {
      dispatch(setBackPanel(0));
      dispatch(setBackPanelFiyatı(0));
    }
  }, [selectedMirror]);

  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-start">
      <RenderModal id="17">
        <Typography variant="caption" fontWeight={700} sx={{ maxWidth: "100px", minWidth: "100px", mr: "1rem" }}>
          Rückwand
        </Typography>
      </RenderModal>

      <input name="id[175]" value={backPanel == 0 ? 2018 : backPanel == 4 ? 2019 : backPanel == 3 ? 9157 : backPanel == 2 ? 9158 : backPanel == 1 ? 2020 : null} />

      <Select onChange={handleChange} value={backPanel} sx={{ height: "2.2rem", flexGrow: "1", fontSize: "0.7rem" }}>
        <MenuItem value={0}>matt weiße Rückwand W1100 ST9</MenuItem>
        <MenuItem value={4}>schwarze Rückwand U999 ST2 leicht glänzend {isAluminium ? "" : "+ 99,00 €"}</MenuItem>
        <MenuItem value={3}>cremebeige Rückwand U222 ST9 + 99,00 €</MenuItem>
        <MenuItem value={2}>arktisgraue Rückwand U788 ST9 + 99,00 €</MenuItem>
        <MenuItem value={1}>verspiegelte Rückwand + 169,00 €</MenuItem>
      </Select>
    </Stack>
  );
};

export default ArkaPanel;
